import { getMarketingPreferences } from "../../selectors";
import { loadFingerprint } from "../loadFingerprint/loadFingerprint";

export const submitPayment = ({
  preOrderCode,
  saveRecurringPaymentInfo,
  paymentType,
  iban,
  ibanAccountHolder,
  eInvoiceOperatorId,
  eInvoicePaymentId,
}) => {
  return async (dispatch, getState, { api }) => {
    const marketingCommunication = getMarketingPreferences(getState());
    const cfp = await dispatch(loadFingerprint());

    return api
      .submitPayment(
        preOrderCode,
        saveRecurringPaymentInfo,
        marketingCommunication,
        paymentType,
        iban,
        ibanAccountHolder,
        cfp,
        eInvoiceOperatorId,
        eInvoicePaymentId,
      )
      .then(
        async (data) => {
          if (data) {
            return {
              wasSuccessful: true,
              payUrl: data.payUrl,
              paymentActionResultEnum: data.paymentActionResultEnum,
              EInvoiceValidationEnum: data.EInvoiceValidationEnum,
            };
          }

          return {
            wasSuccessful: false,
          };
        },
        (err) => {
          return { wasSuccessful: false };
        },
      );
  };
};
